/*eslint-disable */
import React, { useEffect, useState } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Checkbox, 
    Grid, Radio } from "semantic-ui-react";
import { MyNormalInput } from '../dynamicComponent/myInputs';
import { connect } from "react-redux";
import { AllRegex } from "../../utils/validation";
import UpdateAxios from '../axiosComponent/update';
import CreatAxios from '../axiosComponent/create';
import {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from 'react-i18next';
import ReadAxios from '../axiosComponent/read';
const VendorAlert = (props) => {
    const [subcribedAlerts, setsubcribedAlerts] = useState([ 
    { "name":(props.t("alerts.broadcast_alert") || "Broadcast alert"), "alertTypeCode": "ALT-02-01", "smsFlag": "0", "emailFlag": "0" },
    { "name":(props.t("alerts.allocation_alert") || "Allocation alert"), "alertTypeCode": "ALT-02-02", "smsFlag": "0", "emailFlag": "0" },
    { "name":(props.t("alerts.notes_alert") || "Notes alert"), "alertTypeCode": "ALT-02-03", "smsFlag": "0", "emailFlag": "0" },
    { "name":(props.t("alerts.bid_alert") || "Bid alert"), "alertTypeCode": "ALT-02-04", "smsFlag": "0", "emailFlag": "0" },
    { "name":(props.t("alerts.rebid_alert") || "Rebid alert"), "alertTypeCode": "ALT-02-05", "smsFlag": "0", "emailFlag": "0" },
    { "name":(props.t("alerts.edit_shipment") || "Edit shipment"), "alertTypeCode": "ALT-02-06", "smsFlag": "0", "emailFlag": "0" },
    { "name":(props.t("alerts.non_allocation_alert") || "Non-Allocation alert"), "alertTypeCode": "ALT-02-07", "smsFlag": "0", "emailFlag": "0" },]);
    const [email, setEmail] = useState(false);
    const [sms, setSms] = useState(false);
    const [whatsAppConsent, setWhatsAppConsent] = useState(false)
    const [modalOpen, setmodalOpen] = useState(false);

    useEffect(() => {
        // getAllVendors();
        console.log('check bids', props);
        // setTimeout(() => {
            getMasterData(props.id);
                setEmail(props.editParams.emailFlag == 1 ? true : false)
                setSms(props.editParams.smsFlag == 1 ? true : false)
                setWhatsAppConsent(props?.editParams?.whatsAppConsent == 1 ? true : false)

        // }, 700);
      }, []);

      let handleOpen = () => setmodalOpen(true);
        let handleClose = () => {
            setmodalOpen(false);
        };

    const toggle = (e, data) => {
        var checkingSmsT = data.checked;
        var checkingEmailT = data.checked;
        let code = data.name.split(',');
        // for (var j = 0; j < subcribedAlerts.length; j++) { 
        //     if (code[0] === subcribedAlerts[j].alertTypeCode) {
        //         let temp = [...subcribedAlerts];
        //         temp[j].smsFlag = data.checked ? "1" : "0" ;
        //         temp[j].emailFlag = data.checked ? "1" : "0";
        //         setsubcribedAlerts(temp)
        //     }
        // }
        if (code[1] == "email") {
            for (var j = 0; j < subcribedAlerts.length; j++) { 
                if (code[0] === subcribedAlerts[j].alertTypeCode) {
                    let temp = [...subcribedAlerts];
                    temp[j].emailFlag = data.checked ? "1" : "0";
                    setsubcribedAlerts(temp)
                }
            }
            UpdateAxios({ url: `alertSetting/createAlertSetting`, 
        payload: { emailFlag: checkingEmailT ? "1" : "0" , alertCode: code[0], name: data.name, smsFlag:data?.dataValue?.smsFlag }, 
        uniqueId: props.id })
        .then((res) => {
            getMasterData(props.id)
            if (res.status === 200) {
                getMasterData(props.id)
                if (res.data.status === 204) {
                    getMasterData(props.id)
                }
            }
        })
        .catch((err) => {
            console.log(err);
            getMasterData(props.id)
            // this.setState({ loadingData: false, rowData: [] });
        });
        } else if (code[1] == "sms") {
            for (var j = 0; j < subcribedAlerts.length; j++) { 
                if (code[0] === subcribedAlerts[j].alertTypeCode) {
                    let temp = [...subcribedAlerts];
                    temp[j].smsFlag = data.checked ? "1" : "0" ;
                    setsubcribedAlerts(temp)
                }
            }
            UpdateAxios({ url: `alertSetting/createAlertSetting`, 
            payload: { smsFlag: checkingSmsT ? "1" : "0", alertCode: code[0], name: data.name, emailFlag: data?.dataValue?.emailFlag }, 
            uniqueId: props.id })
            .then((res) => {
                console.log('here');
                getMasterData(props.id)
                if (res.status === 200) {
                    getMasterData(props.id)
                    if (res.data.status === 204) {
                        console.log('here in 204');
                        getMasterData(props.id)
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                getMasterData(props.id)
                // this.setState({ loadingData: false, rowData: [] });
            });
        }
        
    }

    const recieveAlerts = (e, data) => {
        console.log(data);
        var checkingSms = data.checked;
        var checkingEmail = data.checked;
        if (data.name === 'userSms') {
            setSms(data.checked)
            UpdateAxios({ url: `alertSetting/setGlobalSettings`, payload: { smsFlag: checkingSms ? '1' : '0' }, uniqueId: props.id })
                .then((res) => {
                    getMasterData(props.id)
                    if (res.status === 200) {
                        getMasterData(props.id)
                        if (res.data.status === 204) {
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // this.setState({ loadingData: false, rowData: [] });
                });
        }

        if (data.name === 'userEmail') {
            setEmail(data.checked) 
            UpdateAxios({ url: `alertSetting/setGlobalSettings`, payload: { emailFlag: checkingEmail ? '1' : '0' }, uniqueId: props.id})
                .then((res) => {
                    getMasterData(props.id)
                    if (res.status === 200) {
                        getMasterData(props.id)
                        if (res.data.status === 204) {
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // this.setState({ loadingData: false, rowData: [] });
                });
        }
    }

    const getMasterData = (uid) => {
        console.log('first call')
        ReadAxios({ url: `alertSetting/getAlertSettingByUser/${uid}`, payload:{u_id: uid} })
            .then((response) => {
                if (response.status === 200 && response.data.resultSet !== "") {
                    let resultSet = response.data.resultSet;
                    if (resultSet.length > 0) {
                        for (var i = 0; i < resultSet.length; i++) { 
                            for (var j = 0; j < subcribedAlerts.length; j++) { 
                                if (resultSet[i].alertTypeCode === subcribedAlerts[j].alertTypeCode) {
                                    let temp = [...subcribedAlerts];
                                    temp[j].smsFlag = resultSet[i].smsFlag;
                                    temp[j].emailFlag = resultSet[i].emailFlag;
                                    setsubcribedAlerts(temp)
                                }
                            }
                        }
                        console.log('check alerts',subcribedAlerts);
                        
                    } else {
                        resultSet = subcribedAlerts
                            setsubcribedAlerts(resultSet)
                    }

                    if (response.data.status === 204) {
                        // alert(response.data.message)
                    }

                }
            })
            .catch((err) => {
                console.log(err);
                // this.setState({ loadingData: false, rowData: [] });
            });
    }

    const changeWhatsAppAlertStatus = async(e, data)=>{
        let whatsAppConsentFlag = data.checked ? "1" : "0"
        let mobileNo = props?.editParams?.mobileNo
        setWhatsAppConsent(data.checked)
        await UpdateAxios({
            url : `whatsappConsentStatus/${mobileNo}/${whatsAppConsentFlag}?userMasterId=${props.id}`
        }).then((res)=>{
            console.log(res);
        }).catch((err)=>{
            console.log(err);
        })
    }

    const { t } = props;
    return (
        <Modal
            onClose={handleClose}
            open={modalOpen}
            size="small"
            className="p-overflow-initial"
            trigger={
                <Button icon
                  type="button"
                  onClick={handleOpen}
                  size="mini"
                  // className="w3-blue w3-round w3-hover-blue"
                >
                  <Icon name='bell' />
                </Button>
              }
        >
            <Modal.Header>{t("alert_title") || "Alert"}</Modal.Header>
            <Modal.Content>
            <div className="container-fluid animated slideInDown pad w3-white">
                    <div className="m-3 pl-3">
                        <div className="ui form">
                            <Grid className="p-2 ml-2 w3-small" columns="7">
                                <Grid.Row>
                                    <Grid.Column>
                                        <label className="labelName">{t("recieve_sms") || "Recieve SMS"}</label>
                                    </Grid.Column>
                                    <Grid.Column width="3">
                                        <Radio toggle name="userSms"
                                            checked={sms}
                                            onChange={recieveAlerts}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <label className="labelName">{t("recieve_email") || "Recieve Email"}</label>
                                    </Grid.Column>
                                    <Grid.Column width="3">
                                        <Radio toggle name="userEmail"
                                            checked={email}
                                            onChange={recieveAlerts}
                                        />
                                    </Grid.Column>

                                    <Grid.Column>
                                        <label className="labelName">{t("recieve_whatsapp") || "Recieve Whatsapp Alerts"}</label>
                                    </Grid.Column>
                                    <Grid.Column width="3">
                                        <Radio toggle name="whatsAppConsent"
                                            checked={whatsAppConsent}
                                            onChange={changeWhatsAppAlertStatus}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    </div>
                </div>

                <div className="container-fluid animated slideInDown pad w3-white">
                    <div className="m-3 pl-3">
                        <div className="ui form">
                            <Grid>
                                <Grid.Row columns="2" className=" ml-2 w3-small">
                                    <Grid.Column>
                                        <label className="font-weight-bold mt-1">{t("alert") || "Alert"}</label>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <table className="w3-table-all w3-bordered w3-round fontertb w3-white w3-small">
                                <thead>
                                    <tr className="w3-light-grey">
                                        <th>{t("type") || "Type"}</th>
                                        <th>{t("email") || "Email"}</th>
                                        <th>{t("sms") || "SMS"}</th>
                                        {/* <th>Whatsapp</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {subcribedAlerts.map((object, index) => (
                                        <>
                                        <tr>
                                        <td><label className="labelName">{object.name}</label></td>
                                        <td><Checkbox
                                            name={object.alertTypeCode + ",email"}
                                            onChange={toggle}
                                            dataValue={object}
                                            defaultChecked={object.emailFlag.toString() == '1' ? true : false}
                                        /></td>
                                        <td><Checkbox
                                            name={object.alertTypeCode + ",sms"}
                                            onChange={toggle}
                                            dataValue={object}
                                            defaultChecked={object.smsFlag.toString() == '1' ? true : false}
                                        /></td>
                                        </tr>
                                        </>
                                    ))} 
                                    
                                
                                </tbody>
                            </table>
                        </div>
                    </div></div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={handleClose}>
                    {props.t("cancel")}
                </Button>
                {/* <Button type='submit' size="mini" color="blue">
                    {props.t("ok")}
                </Button> */}
            </Modal.Actions>
        </Modal>
    )
}

export default connect(null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(translate('user_table')(VendorAlert))
